import { compact, object } from '@art-suite/art-core-ts';
import { ScanOrScanTemplatePartTypeSchema } from '../CommonScanSchemas';
import { ScanDataInMemory } from './ScanDataInMemoryModels';

// ***********************************************************************************
// Private functions for internal ScanDataInMemory use only
// ***********************************************************************************
type ScanPartId = string;
export type ScanDataInMemoryByTypeAndId = Record<ScanOrScanTemplatePartTypeSchema, Record<ScanPartId, ScanDataInMemory>>;

export const getScanDataInMemoryByScanPartId = (scanData: ScanDataInMemory[]): Record<ScanPartId, ScanDataInMemory> =>
  object(scanData, { withKey: ({ scanPartId }) => scanPartId });

export const getScanDataInMemoryByTypeAndId = (scanData: ScanDataInMemory[]): ScanDataInMemoryByTypeAndId =>
  scanData.reduce((acc, scanData) => {
    (acc[scanData.type] ||= {})[scanData.scanPartId] = scanData;
    return acc;
  }, {} as ScanDataInMemoryByTypeAndId);

const EMPTY_OBJECT = {} as Record<string, ScanDataInMemory>;

/**
 * Get all children of a scan part of a given type
 * @param scanPart
 * @param childrenScanPartType
 * @param allScanDataInMemory
 * @returns
 */
export const getScanDataInMemoryChildrenByType = (
  scanPart: ScanDataInMemory,
  childrenScanPartType: ScanOrScanTemplatePartTypeSchema,
  allScanDataInMemory: ScanDataInMemoryByTypeAndId,
): ScanDataInMemory[] => {
  if (!scanPart.childrenScanPartIds) return [];
  const allScanDataInMemoryForType = allScanDataInMemory[childrenScanPartType] || EMPTY_OBJECT;
  return compact(scanPart.childrenScanPartIds.map(childScanPartId => allScanDataInMemoryForType[childScanPartId]));
};

/**
 * Helper function to throw an error if a value is undefined
 * @param value
 * @param comment
 * @returns
 */
export const required = <T>(value: T | undefined, comment?: string): T => {
  if (value === undefined) throw new Error(`Required value is undefined: ${comment}`);
  return value;
};
